import { render } from "./ReviewsSummary.vue?vue&type=template&id=68fa5e46"
import script from "./ReviewsSummary.vue?vue&type=script&lang=js"
export * from "./ReviewsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__